import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M17.4806 8.74092C17.4806 7.75908 18.2765 6.96314 19.2584 6.96314C20.2402 6.96314 21.0361 7.75908 21.0361 8.74092V15.5557M13.9253 13.1854V8.14833L13.925 6.37055C13.925 5.38871 14.721 4.59277 15.7028 4.59277C16.6846 4.59277 17.4806 5.38871 17.4806 6.37055V8.74092M17.4806 8.74092V14.3706M13.9253 8.14833C13.9249 7.16684 13.1291 6.37131 12.1475 6.37131C11.1657 6.37131 10.3697 7.16724 10.3697 8.14909L10.3695 17.289L8.44911 15.3626C7.60653 14.5174 6.21862 14.5944 5.47424 15.5279C4.90466 16.2421 4.88893 17.2523 5.43599 17.9841L9.70229 23.4338C10.5186 24.4765 10.9621 26.0836 10.9621 27.4078M24.5922 15.786L24.5917 12.0002C24.5917 11.0183 23.7957 10.2224 22.8139 10.2224C21.8321 10.2224 21.0361 11.0183 21.0361 12.0002",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Vector_2",
		d: "M24.6221 19.4668L24.9168 20.2634C25.3033 21.308 25.4966 21.8302 25.8776 22.2112C26.2586 22.5922 26.7809 22.7855 27.8255 23.172L28.6221 23.4668L27.8255 23.7616C26.7809 24.1481 26.2586 24.3414 25.8776 24.7224C25.4966 25.1033 25.3033 25.6256 24.9168 26.6702L24.6221 27.4668L24.3273 26.6702C23.9408 25.6256 23.7476 25.1033 23.3665 24.7224C22.9855 24.3414 22.4632 24.1481 21.4186 23.7616L20.6221 23.4668L21.4186 23.172C22.4632 22.7855 22.9855 22.5922 23.3665 22.2112C23.7476 21.8302 23.9408 21.308 24.3273 20.2634L24.6221 19.4668Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHand;
